<template>
  <div class="order-com"
       :class="{nopadding:type==2 || type == 3}" :style="type==100?'padding-bottom:30px':''">
    <span class='tips'
          v-if='type==1'>{{tiotext(model)}}</span>
    <div class="server-info"
         @click='radioChange(model.id)'>
      <!-- @click='radioChange(model.id)' -->
      <div class="select"
           :class='{MR10:radio}'
           v-if='radio && type == 3'>
        <radio :disabled='makeCheck() && type!=3'
               v-if='radio && type == 3'
               :checked='radioArr.indexOf(model.id) > -1' />
      </div>
      <div class="server">
        <booking-order-com :model='model' />
      </div>
    </div>
    <radio :disabled='makeCheck() && type!=3'
           v-if='radio && type != 3'
           @changeRadio='radioChange(model.id)'
           :checked='radioArr.indexOf(model.id) > -1'
           class='radio_class' />
    <!-- <div class="service-detail" v-if='model.state != 99'>
        <div class="select"></div>
        <div class="service-wrap">
          <order-service-list  :model='model.goodsCuringServiceBoList' style="margin-top: 10px"/>
        </div>
      </div> -->

    <div class="btn-wrap type2_bottom"
         v-if='type==1'>
      <!-- <button class="btn-small-highlight-round btn" @click="selectService" v-if='!makeCheck() && !customerId'>选择服务</button> -->

      <button class="btn-small-highlight-round btn"
              @click='diagnosisDetail'>诊断详情</button>

      <button class="btn-small-default-round btn"
              v-if='makeCheck() && model.state != 99'
              @click='concel'>取消</button>
      <!-- <button class="btn-small-default-round btn">
        <div :id="'alldovd'+model.id"
             style="position:absolute;width: 70px;height:40px;z-index:999;">
        </div>联系客服
      </button> -->

    </div>

    <div class="btn-wrap"
         v-if='type==2'>

      <button class="btn-small-highlight-round btn nomargin"
              @click='speedDetail'>进度详情</button>
      <button class="btn-small-highlight-round btn"
              @click='diagnosis'>诊断方案</button>
      <button class="btn-small-default-round btn">
        <div :id="'alldovd'+model.id"
             style="position:absolute;width: 70px;height:40px;z-index:999;">
        </div>联系客服
      </button>
    </div>

    <div class="btn-wrap"
         v-if='type==3'>
      <button class="btn-small-default-round btn"
              @click='diagnosis'>诊断方案</button>
      <button class="btn-small-highlight-round btn"
              @click='effects'
              v-if='!makeCheck()'>效果方案</button>
    </div>


  </div>
</template>

<script>
import zhugeObj from '@/assets/js/track';
import getWXConfig from "@/assets/js/wx.config";
export default {
  data() {
    return {
      serviceList: [],
    }
  },
  props: {
    model: {
      type: Object,
      default: () => {
        return {

        }
      }
    },
    radio: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 1
    },
    customerId: {
      type: Boolean,
      default: false
    },
    radioArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  name: 'order-com',
  created() {


  },
  mounted() {
    setTimeout(() => {
      getWXConfig({ path: 'http://mi.baozheng.cc' })
      let dom = document.getElementById('alldovd' + this.model.id) //
      let key = encodeURIComponent('订单信息已复制，可在输入框中粘贴后发给客服')
      let value = encodeURIComponent('商品编号：' + this.model.goodsCode)
      dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?key=' + key + '&value=' + value + '" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:80px;height:40px;position: relative;top:-10px"></div></template></wx-open-launch-weapp>'

      let launchBtn = document.getElementById('launch-btn')
      if (!launchBtn) {
        return
      }
      launchBtn.addEventListener('launch', function (e) {
        zhugeObj.track({
          title: "个人中心-在线咨询-点击"
        });
      })
      launchBtn.addEventListener('error', function (e) {
        console.log('fail', e.detail)
      })
    }, 1000)
  },
  methods: {
    tiotext(item) {
      if (item.state == 99) {
        return '取消中'
      } else {
        return '已诊断'
      }
    },
    radioChange(id) {
      let tag = this.makeCheck();
      console.log(this.type)
      if (tag && this.type != 3) {
        return;
      }
      if (this.radio) {
        this.$emit('radioChange', id)
      }
    },
    makeCheck() {
      if (this.model.goodsCuringServiceBoList) {
        if (this.model.goodsCuringServiceBoList[0]) {
          if (this.model.goodsCuringServiceBoList[0].curingServiceName == '无法修复') {
            return true;
          }
        }
      }
      if (this.model.state == 99) {
        return true;
      }
      return false;
    },
    concel() {
      this.$emit('goodsConcel', this.model.id);
    },
    contect() {
      this.$emit('contect');
    },
    effects() {
      zhugeObj.track({
        title: '待寄回-点击效果方案',
        content: {
          '点击ID': this.model.id
        }
      })
      if (!this.customerId) {
        this.$router.push({ name: 'effects', query: { id: this.model.id } })
      } else {
        this.$router.push({ name: 'effects', query: { id: this.model.id, goodsCode: this.model.goodsCode } })
      }
    },
    speedDetail() {
      this.$router.push({ name: 'speedDetail', query: { id: this.model.id } })
      zhugeObj.track({
        title: '进度详情-点击',
        content: {
          '订单列表名称': this.type == 2 ? '养护中' : '待寄回'
        }
      })
    },
    diagnosisDetail() {
      if (!this.customerId) {
        this.$router.push({ name: 'diagnosis', query: { id: this.model.id } })
      } else {
        this.$router.push({ name: 'diagnosis', query: { id: this.model.id, goodsCode: this.model.goodsCode } })
      }
      zhugeObj.track({
        title : '订单方案中-诊断详情',
      })
    },
    diagnosis() {
      if (!this.customerId) {
        this.$router.push({ name: 'diagnosis', query: { id: this.model.id } })
      } else {
        this.$router.push({ name: 'diagnosis', query: { id: this.model.id, goodsCode: this.model.goodsCode } })
      }
      zhugeObj.track({
        title : '订单方案中-诊断方案',
      })
    },

  }
}
</script>

<style scoped lang="scss">
.nomargin {
  margin-right: 0 !important;
}
.nopadding {
  padding-bottom: 30px !important;
}
.radio_class {
  position: absolute;
  bottom: 132px;
  right: 32px;
}
.type2_bottom {
  background: #f8f8f8;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 100px;
  .btn {
    margin-left: 20px;
    background: rgba(255, 255, 255, 1) !important;
    box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.06) !important;
    border: none;
    margin-top: 22px;
  }
}
.tips {
  color: #f47779;
  // font-size: 28px;
  // font-size: 28px;
  font-weight: 600;
  position: absolute;
  top: 35px;
  right: 20px;
  text-align: right;
  font-size: 28px;
}
.MR10 {
  margin-right: 10px;
}
.order-com {
  padding: 30px;
  position: relative;
  padding-bottom: 130px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  .server-info {
    // margin-bottom: 20px;
    height: 164px;
    display: flex;
    .select {
      width: 32px;
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .server {
      flex: auto;
    }
  }
  .service-detail {
    display: flex;
    .select {
      width: 32px;
      flex: none;
    }
    .service-wrap {
      flex: auto;
    }
  }
  .btn-wrap {
    margin-top: 22px;
    display: flex;
    flex-direction: row-reverse;
    .btn {
      margin-right: 20px;
    }
  }
}
</style>
